<template>
  <div>
    <section v-for="(bucket, bIndex) in buckets" :key="bIndex" class="provider-grid__bucket">
      <p v-if="bucket.label" class="provider-grid__bucket-label" :data-testid="bucket.labelTestId || undefined">
        {{ bucket.label }}
      </p>
      <ul class="provider-grid__grid" :class="{ 'provider-grid__grid--single': bucket.items.length === 1 }">
        <li
          v-for="item in bucket.items"
          :key="item.key"
          class="v1-group__cell"
          :class="{
            'v1-group__cell--selected': selectedKey === item.key,
            'v1-group__cell--dimmed': item.dimmed,
          }"
          role="button"
          :tabindex="0"
          :data-testid="item.testId"
          @click="$emit('select', item.key)"
          @keydown.enter.prevent="$emit('select', item.key)"
          @keydown.space.prevent="$emit('select', item.key)"
        >
          <img :src="item.logoUrl" :alt="item.alt" class="v1-group__logo" />
        </li>
      </ul>
    </section>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";

export interface ProviderGridItem {
  key: string;
  logoUrl: string;
  alt: string;
  dimmed: boolean;
  testId: string;
}

export interface ProviderGridBucket {
  label?: string;
  labelTestId?: string;
  items: ProviderGridItem[];
}

export default defineComponent({
  name: "ProviderLogoGrid",
  props: {
    buckets: { type: Array as PropType<ProviderGridBucket[]>, default: () => [] },
    selectedKey: { type: String as PropType<string | null>, default: null },
  },
  emits: ["select"],
});
</script>

<style scoped>
.provider-grid__bucket {
  margin-top: 24px;
}

.provider-grid__bucket:first-child {
  margin-top: 0;
}

.provider-grid__bucket-label {
  margin: 0 0 16px;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: -0.5px;
  color: var(--pj-color-brand-gray-750, #3f4340);
}

.provider-grid__grid {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}

@media (min-width: 768px) {
  .provider-grid__bucket-label {
    text-align: center;
  }

  .provider-grid__grid--single .v1-group__cell {
    grid-column: 2;
  }
}

.v1-group__cell {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 60px;
  max-height: 60px;
  padding: 12px 20px;
  border: 1px solid var(--pj-color-brand-gray-350, #c6c7bf);
  border-radius: var(--pj-radius-xl, 16px);
  background: var(--pj-color-brand-white, #ffffff);
  cursor: pointer;
}

.v1-group__cell--selected {
  border-width: 2px;
  border-color: var(--pj-color-brand-gray-850, #222926);
  padding: 11px 19px;
}

.v1-group__cell--dimmed {
  opacity: 0.5;
  cursor: default;
}

.v1-group__logo {
  max-width: 100%;
  max-height: 36px;
  object-fit: contain;
}
</style>
